<template>
  <div class="pwmat-trial-download-background">
    <div class="pwmat-trial-download-banner">
      <div class="pwmat-trial-download-container">
        <div class="pwmat-trial-download-banner-title">{{ $t("pwmatgpu.banner") }}</div>
      </div>

      <img class="pwmat-trial-download-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="pwmat-trial-download-container">

     <div class="pwmat-trial-download-content">
       <div class="pwmat-trial-download-content-title">
         <div class="pwmat-trial-download-content-title-text">MatPL</div>
         <div class="pwmat-trial-download-line"></div>
       </div>

       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text">{{ $t("matpl.describe") }}</p></div>

       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text">{{ $t("matpl.describe2") }}</p></div>

       <div>
         <table class="pwmat-trial-download-introduce-table">
           <tr class="pwmat-trial-download-introduce-th">
             <th class="pwmat-trial-download-introduce-text-th">{{ $t("matpl.tableR0C1") }}</th>
             <th class="pwmat-trial-download-introduce-text-th">{{ $t("matpl.tableR0C2") }}</th>
             <th class="pwmat-trial-download-introduce-text-th">{{ $t("matpl.tableR0C3") }}</th>
             <th class="pwmat-trial-download-introduce-text-th">{{ $t("matpl.tableR0C4") }}</th>
             <th class="pwmat-trial-download-introduce-text-th">{{ $t("matpl.tableR0C5") }}</th>
           </tr>
           <tr class="pwmat-trial-download-introduce-td" >
             <td class="pwmat-trial-download-introduce-text-td">2025.3</td>
             <td class="pwmat-trial-download-introduce-text-td">2025.03.28</td>
             <td class="pwmat-trial-download-introduce-text-td">intel≥2016 or intel oneapi≤2024; cuda≥11.8; gcc≥8.3</td>
             <td class="pwmat-trial-download-introduce-text-td"><a href="https://pan.baidu.com/s/1JgPdSNAIvmc9HBEaCHG3Gw?pwd=pwmt">MatPL-2025.3</a></td>
             <td class="pwmat-trial-download-introduce-text-td"><a href="http://doc.lonxun.com/MatPL">Manual</a></td>
           </tr>
         </table>
       </div>

     </div>
    </div>
  </div>
</template>

<script>
  import {PWMLFF_Download} from "../../helpers/consts"

  export default {
    name: "companyIntroduce",
    data(){
      return {
        PWMLFF_Download
      }
    },
    methods:{
      toPWmatUpdateFunc(){
        this.$router.push({ name: 'PWmatUpdateFunc'})
      }

    }
  }
</script>

<style scoped>
  .pwmat-trial-download-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .pwmat-trial-download-background{
    margin-top: 70px;
  }
  .pwmat-trial-download-banner{
    overflow:hidden;
  }
  .pwmat-trial-download-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .pwmat-trial-download-banner-img{
    min-width:100%;
    height:165px;
  }
  .pwmat-trial-download-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .pwmat-trial-download-content-title{
    padding-top: 50px;
  }
  .pwmat-trial-download-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .pwmat-trial-download-content-note-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-bottom: 0px;
  }
  .pwmat-trial-download-content-info{
    margin-top: 40px;
  }
  .pwmat-trial-download-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .pwmat-trial-download-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }

  .pwmat-trial-download-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .pwmat-trial-download-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .pwmat-trial-download-introduce-td{
    height: 45px;
  }
  .pwmat-trial-download-introduce-td:hover{
    background:rgba(73,145,201,0.1);
  }
  .pwmat-trial-download-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .pwmat-trial-download-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding: 16px;
  }
  .pwmat-trial-download-info-a{
    cursor: pointer;
  }
  .pwmat-trial-download-info-a:hover,
  .pwmat-trial-download-info-a:active{
    text-decoration:underline;
  }
  .pwmat-trial-download-pre{
    background:rgba(73,145,201,0.1);
    padding: 24px 32px;
  }
  @media screen and (max-width:482px) {
    .pwmat-trial-download-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .pwmat-trial-download-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .pwmat-trial-download-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .pwmat-trial-download-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .pwmat-trial-download-container{
      max-width: 1068px;
    }
  }

</style>
